import fluxHelper from './helper';
import fluxStepper from './stepper';
import fluxUI from './ui';

var fluxCoupon = {};

fluxCoupon.init = function() {
    this.onButtonClick();
    this.onFormSubmit();
    this.onChange();


    var sideBar = document.querySelector( '.flux-checkout--has-sidebar' );

    ( function ( $, document ) {
        $( document ).ready( function() {
            if ( sideBar ) {
                $( document.body ).on( 'wc_fragments_refreshed', function() {
                    fluxCoupon.onButtonClick();
                } );

                $( document.body ).on( 'updated_checkout', function() {
                    fluxCoupon.onButtonClick();
                } );

                $( document ).on( 'keydown', '#coupon_code', function ( e ) {
                    if ( e.key === 'Enter' || e.keyCode === 13 ) { 
                        jQuery( "[name=apply_coupon]" ).trigger( 'click' );
                        e.preventDefault();
                    }
                } );

                // Call removeCoupon after the WooCommerce event listener has been added.
                setTimeout( fluxCoupon.removeCoupon, 100 );
            }
        });
    }( jQuery, document ) );
};

/**
 * Login Buttons On Click.
 * 
 * Handle the show and hide of the login form from a custom button.
 */
fluxCoupon.onButtonClick = function() {
    var buttons = document.querySelectorAll( '[data-show-coupon]' );
    Array.from( buttons ).forEach( function( button ) {
        button.setAttribute( 'type', 'button' );
        button.addEventListener( 'click', function( e ) {
            e.preventDefault();

            var form = e.target.closest('.woocommerce-form-coupon__wrapper').querySelector( '.woocommerce-form-coupon' );

            if ( 'none' === form.style.display ) {
                fluxUI.slideDown( form );
            } else {
                fluxUI.slideUp( form );
            }
            
            return false;
        } ); 
    } );
};

fluxCoupon.onFormSubmit = function() {
    jQuery(document).on( 'click', 'button[name=apply_coupon]', async function( e ) {
        
        e.preventDefault();

        var $form = jQuery(this).closest('.woocommerce-form-coupon__wrapper');
        var $row = $form.find( '.form-row' );

        jQuery('.woocommerce-form-coupon__wrapper').find( '.error, .success' ).remove();

        var data = {
            action: 'apply_coupon',
            coupon_code: $form.find( 'input[name="coupon_code"]' ).val(),
            security: wc_checkout_params.apply_coupon_nonce,
        };
        
        fluxStepper.loadSpinner();
    
        let onError = function (err) {};

        await fluxHelper.ajaxRequestWoo( data, function( response ) {
            var message = response.replace( /(<([^>]+)>)/gi, '' );
            
            if ( response.includes( 'woocommerce-error' ) ) {
                $row.addClass( 'woocommerce-invalid' );
                $row.eq(0).append( `<div class='error' aria-hidden='false' aria-live='polite'>${message}</div>` );
            } else {
                jQuery( document.body ).trigger( 'update_checkout', { update_shipping_method: false } );

                jQuery( document.body ).one( 'updated_checkout', function () {
                    jQuery( '.woocommerce-form-coupon__inner .form-row-first' ).append( `<div class="success" aria-hidden="false" aria-live="polite">${message}</div>` );
                } );
            }

        }, onError );

        fluxStepper.removeSpinner();
        
        return false;
    } );
};

fluxCoupon.onChange = function () {
    jQuery( document ).on( 'keyup', '#coupon_code', function () {
        var $btn = jQuery( this ).closest( '.checkout_coupon' ).find( '.flux-coupon-button' );

        if ( jQuery( this ).val().trim() ) {
            $btn.removeClass( 'flux-coupon-button--disabled' );
        } else {
            $btn.addClass( 'flux-coupon-button--disabled' );
        }
    });
};

fluxCoupon.removeCoupon = function ( e ) {
    // Remove WooCommerce's event listener.
    jQuery( document.body ).off( 'click', '.woocommerce-remove-coupon' );

    jQuery( document.body ).on( 'click', '.woocommerce-remove-coupon', function ( e ) {
        e.preventDefault();

        var container = jQuery( this ).parents( '.woocommerce-checkout-review-order' ),
            coupon = jQuery( this ).data( 'coupon' );
    
        container.addClass( 'processing' ).block( {
            message: null,
            overlayCSS: {
                background: '#fff',
                opacity: 0.6
            }
        } );
    
        var data = {
            security: wc_checkout_params.remove_coupon_nonce,
            coupon: coupon
        };
    
        jQuery.ajax( {
            type: 'POST',
            url: wc_checkout_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'remove_coupon' ),
            data: data,
            success: function ( code ) {
                jQuery( '.woocommerce-error, .woocommerce-message' ).remove();
                jQuery( '.woocommerce-form-coupon__wrapper' ).find( '.error, .success' ).remove();

                container.removeClass( 'processing' ).unblock();
    
                if ( code ) {
                    jQuery( document.body ).trigger( 'removed_coupon_in_checkout', [ data.coupon ] );
                    jQuery( document.body ).trigger( 'update_checkout', { update_shipping_method: false } );
    
                    jQuery( document.body ).one( 'updated_checkout', function () {
                        jQuery( '.woocommerce-form-coupon__inner .form-row-first' ).append( `<div class="success" aria-hidden="false" aria-live="polite">${flux_checkout_vars.i18n.coupon_success}</div>` );
                    } );

                    // Remove coupon code from coupon field
                    jQuery( 'form.checkout_coupon' ).find( 'input[name="coupon_code"]' ).val( '' );
                }
            },
            error: function ( jqXHR ) {
                if ( wc_checkout_params.debug_mode ) {
                    /* jshint devel: true */
                    console.log( jqXHR.responseText );
                }
            },
            dataType: 'html'
        } );
    } );
};

export default fluxCoupon;